import { render, staticRenderFns } from "./PainelCard.vue?vue&type=template&id=4c7bdddb&scoped=true&"
import script from "./PainelCard.vue?vue&type=script&lang=js&"
export * from "./PainelCard.vue?vue&type=script&lang=js&"
import style0 from "./PainelCard.vue?vue&type=style&index=0&id=4c7bdddb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7bdddb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VCardText,VCardTitle,VIcon,VProgressCircular})
